import { useMemo } from 'react'
import { useAppStore } from '../store/appStore'
import { isReadOnly, UserPermissionFlag } from '../models/UserModel'

/**
 * An offboarded account keeps its permission flags but may act on none of them: it is
 * confined to reading what it recorded while active, and every write it attempts answers
 * 403 (MD-1497). Denying here is what makes the encounter view read-only for them, rather
 * than each affordance having to ask about the account status itself.
 */
export const useHasPermission = (flag: UserPermissionFlag): boolean => {
    const userModel = useAppStore((state) => state.userModel)

    return useMemo(() => !isReadOnly(userModel) && !!userModel?.[flag], [flag, userModel])
}
